import React from 'react';
import PropTypes from 'prop-types';
import { Form as FinalForm } from 'react-final-form';
import { Field } from 'react-final-form-html5-validation';
import {
  Button,
  ControlLabel,
  Form,
  FormGroup,
} from 'react-bootstrap';
import { FinalFormRocketMatterClientSelector } from './RocketMatterClientSelector'
import { FinalFormRocketMatterMatterSelector } from "./RocketMatterMatterSelector";
import _ from 'lodash';

export default class RocketMatterCaseFolderSettingsForm extends React.Component {
  static propTypes = {
    connectionId: PropTypes.number.isRequired,
    settings: PropTypes.object.isRequired,
    onSave: PropTypes.func.isRequired,
  };

  render() {
    const {connectionId, onSave, settings} = this.props;

    return (
      <FinalForm initialValues={settings} onSubmit={onSave}>
        {({handleSubmit, pristine, values, submitting}) =>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <ControlLabel>Client</ControlLabel>
              <Field name="client_id"
                     component={FinalFormRocketMatterClientSelector}
                     connectionId={connectionId}
                     clearable={false}
                     required={true}
              />
            </FormGroup>

            {_.get(values, 'client_id') &&
              <FormGroup>
                <ControlLabel>Matter</ControlLabel>
                <Field name="matter_id"
                       component={FinalFormRocketMatterMatterSelector}
                       connectionId={connectionId}
                       clientId={_.get(values, 'client_id')}
                       clearable={false}
                       required={true}
                 />
              </FormGroup>
            }

            <FormGroup>
              <Button type="submit" bsStyle="primary" disabled={pristine || submitting}>Save</Button>
            </FormGroup>
          </Form>
        }
      </FinalForm>
    );
  }
};



// WEBPACK FOOTER //
// ./src/CaseFolder/Integrations/RocketMatter/RocketMatterCaseFolderSettingsForm.jsx